import { remove } from '../index';

export function removeTimeline(obj) {
  return remove('/timelines', obj);
}
